<ng-container *ngIf="showNotification && notification">
  <ng-container *ngIf="notification.notificationText as notificationText">
    <div class="background-{{ notification.background?.color }} notification">
      <span class="message mat-subtitle-1">{{ notificationText }}</span>
      <div class="exit" (click)="exitNotification()">X</div>
    </div>
  </ng-container>
</ng-container>
